// extracted by mini-css-extract-plugin
module.exports = {"container":"cms-page-content_container__s7F8n","header":"cms-page-content_header__P1psm","wrapper":"cms-page-content_wrapper__5hlM9"};